import { siteCopy } from "../../content";
import { HOTSPOTS, type HotspotId } from "../../config/hotspots";
import styles from "./RoomObjectList.module.css";

const copy = siteCopy.scene;

export type RoomObjectListProps = Readonly<{
  onHotspotActivate: (id: HotspotId) => void;
  discoveredHotspotIds?: readonly HotspotId[];
}>;

/**
 * The room as plain text: every hotspot as a real button, in the same order and
 * with the same number as its marker in the scene. It opens from the footer, so
 * the list takes none of the room's height.
 */
export function RoomObjectList({
  onHotspotActivate,
  discoveredHotspotIds = [],
}: RoomObjectListProps) {
  const discovered = new Set(discoveredHotspotIds);

  return (
    <nav className={styles.list} aria-label={copy.objectMenuNavLabel}>
      <ul>
        {HOTSPOTS.map((hotspot, index) => {
          const isDiscovered = discovered.has(hotspot.id);

          return (
            <li key={hotspot.id}>
              <button
                className={styles.object}
                type="button"
                data-discovered={isDiscovered ? "true" : "false"}
                onClick={() => onHotspotActivate(hotspot.id)}
              >
                <span className={styles.marker} aria-hidden="true">
                  {isDiscovered ? "✓" : index + 1}
                </span>
                <span>
                  <strong>{hotspot.shortLabel}</strong>
                  <small>{hotspot.description}</small>
                </span>
                <span className={styles.arrow} aria-hidden="true">
                  →
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
